<template>
  <v-img
    v-if="image && image.src"
    :height="height"
    :class="{ 'sortable-element': sortable }"
    :min-width="minWidth"
    :transition="false"
    :aspect-ratio="aspectRatio"
    :alt="image.alt"
    :contain="keepImageAspectRatio"
    :src="image.src"
    @click="$emit('click:item')"
  />
  <v-responsive
    v-else
    :aspect-ratio="aspectRatio"
    :class="{ 'sortable-element': sortable }"
    :height="height"
    :min-width="minWidth"
  >
    <v-layout
      align-center
      fill-height
      justify-center
      class="icon--item"
    >
      <v-icon
        :size="iconSize"
        :color="iconColor"
        v-text="computedIcon"
      />
    </v-layout>
  </v-responsive>
</template>

<script>
export default {
  name: 'NxListItemImage',
  props: {
    normal: Boolean,
    mosaic: Boolean,
    selection: Boolean,
    sortable: Boolean,
    grabbing: Boolean,
    hovered: Boolean,
    bag: Boolean,
    image: Object,
    keepImageAspectRatio: Boolean,
    icon: Object,
  },
  computed: {
    height() {
      if (this.mosaic) {
        return '128px';
      }
      return null;
    },
    minWidth() {
      if (this.normal) {
        return '86px';
      }
      if (this.selection) {
        return '58px';
      }
      if (this.bag) {
        return '50px';
      }
      if (this.mosaic) {
        return null;
      }
      return '40px';
    },
    aspectRatio() {
      if (this.image && this.image.aspectRatio) {
        return this.image.aspectRatio;
      }
      if (this.mosaic) {
        return '16/9';
      }
      return '1';
    },
    computedIcon() {
      if (this.sortable && this.hovered && !this.grabbing) {
        return 'drag_handle';
      }
      return this.icon ? this.icon.name : 'error_outline';
    },
    iconSize() {
      if (this.normal || this.mosaic) {
        return '32';
      }
      return null;
    },
    iconColor() {
      if (this.bag) {
        return 'nx-primary--lighten-3';
      }
      return 'primary';
    },
  },
};
</script>
